import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsisV, faTimes } from '@fortawesome/pro-light-svg-icons';
import i18next from 'core/i18n';
import { Theme, SmallTitle, palettes } from '@indigo-ag/component-module';
import { Menu, MenuItem } from '@indigo-ag/component-module/dist/commonjs/_deprecated';
import { faCommentMedical } from '@fortawesome/pro-regular-svg-icons';

import { createStylesHook } from 'shared/hooks/createStylesHook';
import { IconButton } from 'shared';

const useStyles = createStylesHook((theme: Theme) => ({
  docIconColor: {
    color: palettes.coastal.core.mediumBlue,
    fontSize: theme.typography.pxToRem(24)
  },
  optionTextStyles: {
    color: `${palettes.coastal.core.mediumBlue} !important`,
    cursor: 'pointer',
    marginLeft: '8px !important'
  }
}));

interface ModalOptionsMenuProps {
  addCommentAction: () => void;
  isDisabled: boolean;
  removeFileAction?: () => void;
}

export const ModalOptionsMenu: React.FunctionComponent<ModalOptionsMenuProps> = ({
  addCommentAction,
  isDisabled,
  removeFileAction
}) => {
  /**
   * State
   */
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  /**
   * Styles
   */
  const classes = useStyles();

  const handleMenuOpen: React.MouseEventHandler<HTMLDivElement> = e => {
    setAnchorEl(e.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleAddComment = () => {
    addCommentAction();
    handleMenuClose();
  };

  const handleRemoveAction = () => {
    if (removeFileAction) {
      removeFileAction();
    }
    handleMenuClose();
  };

  return (
    <>
      <div style={{ display: 'flex', alignItems: 'center' }} onClick={handleMenuOpen}>
        <IconButton icon={faEllipsisV} size="small" className={classes.docIconColor} />
        <SmallTitle className={classes.optionTextStyles}>{i18next.t('options')}</SmallTitle>
      </div>
      <Menu
        id="modal-options-menu"
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        getContentAnchorEl={null}
        anchorOrigin={{
          horizontal: 'left',
          vertical: 'top'
        }}
        transformOrigin={{
          horizontal: 'right',
          vertical: 'bottom'
        }}
      >
        {removeFileAction && (
          <MenuItem onClick={handleRemoveAction}>
            <FontAwesomeIcon
              icon={faTimes}
              title={i18next.t('remove')}
              className={classes.docIconColor}
              style={{ marginRight: 12 }}
            />
            {i18next.t('remove')}
          </MenuItem>
        )}

        <MenuItem onClick={handleAddComment} disabled={isDisabled}>
          <FontAwesomeIcon
            icon={faCommentMedical}
            title={i18next.t('addComment')}
            className={classes.docIconColor}
            style={{ marginRight: 6 }}
          />
          {i18next.t('addComment')}
        </MenuItem>
      </Menu>
    </>
  );
};
